import { LogoGithub, LogoLinkedin, LogoInstagram } from '@carbon/icons-react';

export const socials = [
  {
    key: 'linkedin',
    Icon: LogoLinkedin,
    href: 'https://www.linkedin.com/in/rares-sabin-vlad-65076b24b/',
  },
  {
    key: 'github',
    Icon: LogoGithub,
    href: 'https://github.com/Lunetistul1976',
  },
  {
    key: 'instagram',
    Icon: LogoInstagram,
    href: 'https://www.instagram.com/raresv03/',
  },
];
